import moment from "moment";

export const formatMillisecondsDate = (millisecondsDate) => {
  return moment.unix(millisecondsDate/1000).format('DD/MM/yyyy')
}